import { render, staticRenderFns } from "./point-model.vue?vue&type=template&id=0bdfab08&"
import script from "./point-model.vue?vue&type=script&lang=js&"
export * from "./point-model.vue?vue&type=script&lang=js&"
import style0 from "./point-model.vue?vue&type=style&index=0&id=0bdfab08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports